import { teamRoles } from "../../constants/teamRoles";
import createDocumentData from "../../utils/createDocumentData";
import runTransaction from "../../utils/runTransaction";

import createDiscussionChannelData from "../discussion/createDiscussionChannelData";
import createVoiceOffer from "../offers/createVoiceOffer";
import createWorkData from "../works/createWorkData";

import productionStatuses from "./constants/productionStatuses";
import updateProduction from "./updateProduction";

export default async function createProductionNew(
	firebase,
	data,
	{ articles, readers, transaction, partial = false, discussion = false, debug = false } = {},
) {
	if (!data.publisher) {
		throw new Error("Missing publisher");
	}

	if (!data.work) {
		throw new Error("Missing work");
	}

	const userRefs = readers?.map(({ id }) => firebase.firestore().collection("users").doc(id));

	const channels = [
		{
			id: "team",
			name: "team",
			teamRoles: [
				teamRoles.EDITOR,
				teamRoles.PROOFER,
				teamRoles.MANAGER,
				teamRoles.RECORDER,
				teamRoles.SUBCONTRACTOR,
			],
		},
		{
			id: "publisher",
			name: "publisher",
			users: data.publisherManagers || [],
			teamRoles: [teamRoles.MANAGER, teamRoles.PUBLISHER_MANAGER],
		},
		{
			id: "admin",
			name: "admin",
			teamRoles: [teamRoles.MANAGER],
		},
	];

	data.producer = data.producer || "HfvG4FQfXWpWv6dzqM5E";

	if (!data.status) {
		data.status = data.draft ? productionStatuses.DRAFT : productionStatuses.OFFER;
	}

	return runTransaction(
		firebase,
		[data.publisher?.ref, data.work?.ref, userRefs],
		async (transaction, [publisher, work, users]) => {
			const production = await updateProduction(
				firebase,
				createDocumentData(firebase, "productions", {
					...data,
					createdBy: data.createdBy?.email || null,
				}),
				{
					articles,
					transaction,
					partial,
				},
			);

			// If the work does not exist, create it
			if (!work?.exists) {
				transaction.set(work.ref, createWorkData(firebase, { ...data.work, publisher }));
			}

			for (const reader of readers || []) {
				const user = users.find((user) => user.id === reader.id);

				await createVoiceOffer(
					firebase,
					{
						user,
						voiceId: 1,
						price: reader?.price,
						createdBy: data.createdBy,
						production,
					},
					{ transaction },
				);
			}

			if (discussion) {
				for (const { id, name, users, teamRoles } of channels) {
					const channel = createDiscussionChannelData(firebase, {
						id: `${production.id}-${id}`,
						name,
						users,
						teamRoles,
						producerId: data.producer,
						subject: {
							...production,
							name: production.title,
							language: production.language,
						},
						seenByUserIds: data.createdBy?.id ? [data.createdBy.id] : [],
						createdBy: data.createdBy || null,
					});

					transaction.set(channel.ref, channel);
				}
			}

			return production;
		},
		transaction,
		debug,
	);
}
